import React from 'react'
import { FieldArray } from 'redux-form'
import { RepeaterDefaultAdd } from '../../form/Repeater'
import { AddInstitutionsField } from './AddInstitutionsField'
import { AddPersonsField } from './AddPersonsField'

const AuthorContainer = ({ fields, changeFieldValue }) => (
  <div className="repeater-field">
    <div className="field-label">Author</div>
    {fields.map((member, index) => (
      <AddPersonsField
        key={index}
        member={member}
        index={index}
        fields={fields}
        //items={items}
        changeFieldValue={changeFieldValue}
      />
    ))}
    <RepeaterDefaultAdd fields={fields} addFn={() => fields.push({})} label="Add author" />
  </div>
)

const AuthorInstContainer = ({ fields, changeFieldValue, title = '' }) => (
  <div className="repeater-field">
    <div className="field-label">{title}</div>
    {fields.map((member, index) => (
      <AddInstitutionsField
        key={index}
        member={member}
        index={index}
        fields={fields}
        //items={items}
        changeFieldValue={changeFieldValue}
      />
    ))}
    <RepeaterDefaultAdd fields={fields} addFn={() => fields.push({})} label={`Add ${title}`} />
  </div>
)

export const DocumentAuthors = (props) => (
  <FieldArray name="documents_authors" component={AuthorContainer} {...props} />
)

export const DocumentAuthorsInst = (props) => (
  <FieldArray name="documents_authors_institutions" component={AuthorInstContainer} {...props} />
)
